import AbacusModal from "@/components/AbacusModal/index.vue";
import EquipmentListItem from "@/components/Equipment/parts/EquipmentCollapse/parts/EquipmentDisplay/parts/EquipmentSelector/parts/EquipmentList/parts/EquipmentListItem/EquipmentListItem.component";
import { Category } from "@/models/categories.model";
import { Equipment, EquipmentType, Extractor, RotationType } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {
    EquipmentListItem,
    AbacusModal,
  },
})
export default class EquipmentListItemComponent extends Vue {
  @Prop() category!: Category;
  @Prop() equipment!: Equipment;

  @Prop()
  fields!: any[];

  get defaultImage(): string {
    return Vue.prototype.defaultImg;
  }

  getColumns(key: string): string {
    return this.fields.find((v) => v.key == key)?.cols;
  }
  get isExtractor(): boolean {
    return this.category.equipmentType == EquipmentType.extractor;
  }

  isAirLocks(): boolean {
    return (
      this.category.equipmentType == EquipmentType.wastesAirLock ||
      this.category.equipmentType == EquipmentType.workersAirLock
    );
  }

  isAirEntry(): boolean {
    return (
      this.category.equipmentType == EquipmentType.eacm ||
      this.category.equipmentType == EquipmentType.ear
    );
  }

  /**
   * Show Abacus modal
   */
  showAbacus(): void {
    this.$bvModal.show(`showAbacus-${this.equipment.type}-${this.equipment.id}`);
  }

  /**
   * Hide Abacus modal
   */
  onAbacusClose(): void {
    this.$bvModal.hide(`showAbacus-${this.equipment.type}-${this.equipment.id}`);
  }

  get rotationType(): string {
    if (this.isExtractor) {
      if ((this.equipment as Extractor).rotation_type === RotationType.variable) {
        return this.$t("components.equipmentPage.equipmentDisplay.rotationVariable").toString();
      } else {
        return this.$t("components.equipmentPage.equipmentDisplay.rotationSet").toString();
      }
    } else {
      return "";
    }
  }
}
